export default __webpack_public_path__ + "static/media/454.56b89174.png";